<template>
  <div></div>
</template>

<script>
import { conditionSearch, search, getSearchInfo } from "@/api/table";
import { Message } from "element-ui";
// import Swal from 'sweetalert2';
export default {
  name: "base-mixins",
  components: {},
  props: { msg: String },
  data() {
    return {
      yearList: [],
      makeList: [],
      modelList: [],
      qualifierList: [],
      bodytypeList: [],
      searchkeywords: {
        year: "",
        make: "",
        model: "",
        qualifier: "",
        bodytype: "",
        sku: "",
      },
      value: "",
      isMobile: false,
      secondStatus: true,
      thirdStatus: true,
      fourStatus: true,
      fiveStatus: true,
      searchResutl: { qualifier: "" },
      searchResutl2: { qualifier: "" },
      firstTabLoadingStatus: false,
      tabData: "",
      picModel: "",
      noneFlag: false,
      hasSubmodel: false,
      submitFlag: true,
      showSeo: "",
    };
  },
  created() {
    // 如果显示设备为手机，dialog需要全屏显示
    this.fullScreen();
    // created之后，需要获取年份数据
    // console.log(innerWidth);
  },
  watch: {
    searchkeywords: {
      handler: function () {
        this.checkSubmit();
      },
      deep: true,
    },
  },
  mounted() {
    const params = {
      selectType: "YEAR",
      year: this.searchkeywords["year"],
      make: this.searchkeywords["make"],
    };
    this.applyCondition(params, "yearList");
    this.searchQueryInit();
    this.initSeo()
    window.onresize = () => {
      this.fullScreen();
      this.getHeight(false);
      this.initSeo()
      // this.setTabPosition();
    };
  },
  methods: {
    getHeight(flag) {
      this.$nextTick(() => {
        const domObj = document.getElementsByClassName("index-container")[0];
        window.parent.postMessage(
          {
            type: "HEIGHT",
            height: domObj.offsetHeight,
          },
          "*"
        );
      });
      if (flag) {
        setTimeout(() => {
          const domObj = document.getElementsByClassName("index-container")[0];
          window.parent.postMessage(
            {
              type: "HEIGHT",
              height: domObj.offsetHeight,
            },
            "*"
          );
        }, 2000);
        setTimeout(() => {
          const domObj = document.getElementsByClassName("index-container")[0];
          window.parent.postMessage(
            {
              type: "HEIGHT",
              height: domObj.offsetHeight,
            },
            "*"
          );
        }, 8000);
      }
    },
    searchQueryInit() {
      console.log(this.$route);
      // 由xkglow中传过来的参数并设置初始列表
      this.searchkeywords.year = this.$route.query["year"];
      this.searchkeywords.make = this.$route.query["make"];
      this.searchkeywords.model = this.$route.query["model"];
      this.searchkeywords.sku = this.$route.query["sku"];
      // console.log(this.searchkeywords, 'searchkeywords')
      // this.picModel = this.$route.query["show"];
      if (this.searchkeywords.year !== "YEAR") {
        this.secondStatus = false;
        // year参数不为空，需要加载厂商list
        this.searchMake(false);
        if (this.searchkeywords.make !== "MAKE") {
          this.thirdStatus = false;
          this.searchModel();
          // this.handleClick();
          this.dealFourLevel();
        }
      }
    },
    // 判断是否是四级
    dealFourLevel() {
      const params = {
        selectType: "QUALIFIER",
        year: this.searchkeywords["year"],
        make: this.searchkeywords["make"],
        model: this.searchkeywords["model"],
      };
      conditionSearch(params).then((res) => {
        if (res.resultStatus) {
          const conditionArr = res.resultData.filter((item) => {
            return item.conditionName;
          });
          if (conditionArr.length == 0) {
            this.handleClick();
            this.checkSubmit();
          } else {
            this.fourStatus = false;
            this.hasSubmodel = true;
            this.qualifierList = [];
            for (let index = 0; index < conditionArr.length; index++) {
              this.qualifierList.push(conditionArr[index]["conditionName"]);
            }
            this.checkSubmit();
            this.$nextTick(() => {
              this.getHeight();
            });
          }
        }
      });
    },
    checkSubmit() {
      const searchkeywords = {
        year: this.searchkeywords.year,
        make: this.searchkeywords.make,
        model: this.searchkeywords.model,
        qualifier: this.searchkeywords.qualifier,
        bodytype: this.searchkeywords.bodytype,
      };
      let flag = true;
      if (this.qualifierList.length > 0) {
        for (let key in searchkeywords) {
          if (key != "bodytype" && !searchkeywords[key]) {
            this.submitFlag = true;
            flag = false;
          }
        }
      }
      if (this.bodytypeList.length > 0) {
        for (let key in searchkeywords) {
          if (!searchkeywords[key]) {
            this.submitFlag = true;
            flag = false;
          }
        }
      }
      const param = {
        year: searchkeywords.year,
        make: searchkeywords.make,
        model: searchkeywords.model,
      };
      for (let key in param) {
        if (!param[key]) {
          this.submitFlag = true;
          flag = false;
        }
      }
      flag ? (this.submitFlag = false) : (this.submitFlag = true);
    },
    handleClick() {
      const params = {
        year: this.searchkeywords["year"] || "",
        make: this.searchkeywords["make"] || "",
        model: this.searchkeywords["model"] || "",
        qualifier: this.searchkeywords["qualifier"] || "",
        bodyType: this.searchkeywords["bodytype"] || "",
        searchType: this.searchType,
      };
      if (
        !this.searchkeywords["year"] ||
        !this.searchkeywords["model"] ||
        !this.searchkeywords["make"]
      ) {
        Message({
          message: "Please fill all three dropdown options.",
          type: "warning",
          duration: 1000,
        });
        // const error = "Please fill all three dropdown options.";
        // Swal.fire({ title: error, timer: 2000, showConfirmButton: false });
        return;
      }
      if (this.qualifierList.length > 0 && !this.searchkeywords["qualifier"]) {
        Message({
          message: "Please fill all three dropdown options.",
          type: "warning",
          duration: 1000,
        });
        return;
      }
      if (this.bodytypeList.length > 0 && !this.searchkeywords["bodytype"]) {
        Message({
          message: "Please fill all three dropdown options.",
          type: "warning",
          duration: 1000,
        });
        return;
      }
      this.firstTabLoadingStatus = true;
      const path = this.$route.path;
      this.$router.replace({
        path: path,
        query: {
          year: this.searchkeywords["year"] || "",
          make: this.searchkeywords["make"] || "",
          model: this.searchkeywords["model"] || "",
          sku: this.searchkeywords["sku"] || "",
          // show: this.$route.query["show"] || ""
        },
      });
      window.parent.postMessage(
        {
          type: "TITLE",
          title: `${params.year} ${params.make} ${params.model}`,
        },
        "*"
      );
      search(params)
        .then((res) => {
          //console.log(res);
          this.firstTabLoadingStatus = false;
          this.searchResutl = res.resultData[0] || undefined;
          this.searchResutl2 = res.resultData[1] || undefined;
          //console.log(this.searchResutl2, "second result");
          // 因为qualifier数量不一定，需要使用循环生成tab的数据，用于生成动态tab
          let application = [];
          res.resultData.forEach((item) => {
            const applications = item.applications.filter((application) => {
              //console.log(application.products.length, "product length");
              return application.products.length !== 0;
            });
            application.push(...applications);
          });
          this.tabData =
            application.length > 0 ? { applications: application } : "";
          this.noneFlag = application.length == 0 ? true : false;
          //console.log(typeof res);
          //console.log(this.tabData);
          this.$nextTick(() => {
            this.getHeight(true);
            this.initSeo()
          });
        })
        .catch((err) => {
          err;
          //console.log(err);
          this.firstTabLoadingStatus = false;
        });
    },
    initSeo() {
      const params = {
        year: this.searchkeywords["year"] || "",
        make: this.searchkeywords["make"] || "",
        model: this.searchkeywords["model"] || "",
        qualifier: this.searchkeywords["qualifier"] || "",
        bodyType: this.searchkeywords["bodytype"] || "",
        searchType: this.searchType,
      };
      getSearchInfo(params).then((res) => {
        console.log(res);
        this.showSeo = res.resultData.seo;
        if (this.showSeo) {
          this.showSeo = this.showSeo.replace(/\r|\n/g, "");
          this.showSeo = JSON.parse(this.showSeo);
          window.parent.postMessage(
            {
              type: "SHOWSEO",
              show: true
            },
            "*"
          );
        }
        console.log(this.showSeo, "seoseoseoseoseoseo");
      });
    },
    fullScreen() {
      if (innerWidth <= 414) {
        this.isMobile = true;
      } else {
        this.isMobile = false;
      }
    },
    /**
     * @description: 下拉框中的条件搜索
     * @param {object} params 搜索条件
     * @param {string} store 搜索结果存储位置
     */
    applyCondition(params, store) {
      conditionSearch(params).then((res) => {
        const data = res.resultData.filter((item) => {
          return item.conditionName;
        });
        this[store] = [];
        for (let index = 0; index < data.length; index++) {
          this[store].push(data[index]["conditionName"]);
        }
        //console.log(this[store]);
        this.checkSubmit();
      });
    },
    searchMake(clean) {
      this.secondStatus = false;
      const params = {
        selectType: "MAKE",
        year: this.searchkeywords["year"],
        make: this.searchkeywords["make"],
      };
      this.applyCondition(params, "makeList");
      if (clean) {
        this.searchkeywords["make"] = "";
        this.searchkeywords["model"] = "";
        this.searchkeywords["qualifier"] = "";
        this.searchkeywords["bodytype"] = "";
        this.qualifierList = [];
        this.bodytypeList = [];
      }
    },
    searchModel(clean) {
      this.thirdStatus = false;
      const params = {
        selectType: "MODEL",
        year: this.searchkeywords["year"],
        make: this.searchkeywords["make"],
      };
      this.applyCondition(params, "modelList");
      if (clean) {
        this.searchkeywords["model"] = "";
        this.searchkeywords["qualifier"] = "";
        this.searchkeywords["bodytype"] = "";
        this.qualifierList = [];
        this.bodytypeList = [];
      }
    },
    searchQualifier(clean) {
      this.fourStatus = false;
      const params = {
        selectType: "QUALIFIER",
        year: this.searchkeywords["year"],
        make: this.searchkeywords["make"],
        model: this.searchkeywords["model"],
      };
      this.applyCondition(params, "qualifierList");
      if (clean) {
        this.searchkeywords["qualifier"] = "";
        this.searchkeywords["bodytype"] = "";
        this.qualifierList = [];
        this.bodytypeList = [];
      }
    },
    searchBodytype(clean) {
      this.hasSubmodel = false;
      this.fiveStatus = false;
      const params = {
        selectType: "BODYTYPE",
        year: this.searchkeywords["year"],
        make: this.searchkeywords["make"],
        model: this.searchkeywords["model"],
        qualifier: this.searchkeywords["qualifier"],
      };
      this.applyCondition(params, "bodytypeList");
      if (clean) {
        this.searchkeywords["bodytype"] = "";
        this.bodytypeList = [];
      }
    },
  },
};
</script>

<style scoped></style>
